import React, { PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';

import {
  STATIC_WIZARD_PARAMS,
  STATIC_WIZARD_PARAMS_KEYS,
} from '../../shared/constants';
import { ContentfulLayout } from '../../shared/constants/Contentful.constants';

import Footer from '../organisms/footer/Footer';
import Navigation from '../organisms/navigation/Navigation';

interface Props extends PropsWithChildren {
  layoutType: ContentfulLayout;
  pageType?: string;
  backgroundColor?: string;
}

const BaseLayout = ({
  children,
  layoutType,
  pageType,
  backgroundColor,
}: Props) => {
  const [checkParams, setCheckParams] = useState('default');
  useEffect(() => {
    const { location } = window;
    const searchParams = new URLSearchParams(location.search);
    if (location.hash && location.hash !== ('#/' || '#')) {
      document
        .querySelector(location.hash)
        ?.scrollIntoView({ behavior: 'smooth' });
    }

    // TODO: Check if we can handle opendomain query parameter in a different way, maybe create a seperate page with isolated layout.
    if (
      searchParams.get(STATIC_WIZARD_PARAMS_KEYS.userFrom) ===
      STATIC_WIZARD_PARAMS.openDomain
    ) {
      setCheckParams(STATIC_WIZARD_PARAMS.openDomain);
    }
  }, []);

  return (
    <LayoutWrapper backgroundColor={backgroundColor}>
      <div id="modal-root" />
      <div id="overlay-root" />
      {layoutType !== ContentfulLayout.ISOLATED &&
        checkParams !== STATIC_WIZARD_PARAMS.openDomain && (
          <Navigation
            disableMenu={layoutType === ContentfulLayout.RESTRICTED}
          />
        )}
      <main>{children}</main>
      {layoutType !== ContentfulLayout.ISOLATED &&
        checkParams !== STATIC_WIZARD_PARAMS.openDomain && (
          <FooterWrapper>
            <Footer />
          </FooterWrapper>
        )}
    </LayoutWrapper>
  );
};

export default BaseLayout;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

const LayoutWrapper = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor || 'unset'};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;
